<template>
    <div
        class="lni-c-box--content lni-u-mhauto lni-u-mv3"
    >
        <LniRetaliationForm
            id="retaliation-form"
        />
    </div>
</template>

<script>

export default {
    name: 'HomePage',
}; </script>